import * as Yup from 'yup';
import { FilePollResponseStatus } from './file';

type AppInfo = {
  appName: string,
  appOwnerEmail: string,
};

type EmbeddedPollResponseDone = {
  status: FilePollResponseStatus.Ok
}

type EmbeddedPollResponseError = {
  status: FilePollResponseStatus.Error
  appInfo?: AppInfo
}

type EmbeddedPollResponseConverting = {
  status: FilePollResponseStatus.Converting
}

export type EmbeddedPollResponse =
  | EmbeddedPollResponseDone
  | EmbeddedPollResponseConverting
  | EmbeddedPollResponseError

export type EmbeddedData = {
  docGuids: string[],
  usingTemplate: boolean,
  parentUrl: string,
  redirectUrl: null | string,
  editedTemplateGuid: null | string,
  isSelfSign: null | boolean,
  locale: null | string,
};

export const embeddedDataSchema = Yup.object<EmbeddedData>({
  docGuids: Yup.array(),
  usingTemplate: Yup.bool(),
  parentUrl: Yup.string(),
  redirectUrl: Yup.string().nullable(),
  editedTemplateGuid: Yup.string().nullable(),
  isSelfSign: Yup.bool().nullable(),
  locale: Yup.string().nullable(),
}).notRequired();
